import React from "react";
import { Link, withRouter } from "react-router-dom";
import menuBNT from "Assets/Images/menuBNT.png";
import menuHomeW from "Assets/Images/menuHomeW.png";
import menuCounselW from "Assets/Images/menuCounselW.png";
import menuDiagnosisW from "Assets/Images/menuDiagnosisW.png";
import menuIntroductionW from "Assets/Images/menuIntroductionW.png";
import menuReservationW from "Assets/Images/menuReservationW.png";

export default withRouter(({ location: { pathname } }) => (
  <div className="menu">
    <div className="menuBNT">
      <img src={menuBNT} alt="menu" />
    </div>
    <div className="menuLink">
      <div id="linkBefore" className="menuLinkItem" />
      <Link to="/" id="linkHome" className="menuLinkItem" />
      <Link to="/counsel" id="linkCounsel" className="menuLinkItem" />
      <Link to="/diagnosis" id="linkDiagnosis" className="menuLinkItem" />
      <Link to="/introduction" id="linkIntroduction" className="menuLinkItem" />
      <Link to="/reservation" id="linkReservation" className="menuLinkItem" />
      <div id="linkAfter" className="menuLinkItem" />
    </div>
    <div className="menuW">
      <img
        src={menuHomeW}
        alt="menu"
        className={pathname === "/" ? "" : "invisible"}
      />
      <img
        src={menuCounselW}
        alt="menu"
        className={pathname === "/counsel" ? "" : "invisible"}
      />
      <img
        src={menuDiagnosisW}
        alt="menu"
        className={pathname === "/diagnosis" ? "" : "invisible"}
      />
      <img
        src={menuIntroductionW}
        alt="menu"
        className={pathname === "/introduction" ? "" : "invisible"}
      />
      <img
        src={menuReservationW}
        alt="menu"
        className={pathname === "/reservation" ? "" : "invisible"}
      />
    </div>
  </div>
));
